import {observer} from 'mobx-react-lite';
import * as React from 'react';
import {FC, useState} from 'react';

import Background from '../../assets/images/create_project_bg.png';
import {Button} from '../../components/Button';
import {Card} from '../../components/Card';
import {ChoosePlanState} from './ChoosePlanState';

export const ChoosePlanView: FC = observer(() => {
    const [state] = useState(() => new ChoosePlanState());

    return <div
        style={{
            backgroundImage: `url(${Background})`,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
        }}
        className="flex h-full items-center w-screen -mx-6 -my-5 p-6"
    >
        <div className="w-full max-w-lg sm:w-3/5">
            <h1 className="leading-tight mb-8 text-6xl">
                <span className="text-m-green">Choose</span> <br />
                your Muscula plan
            </h1>
            <Card
                title="$14 monthly"
                footer={
                    <div>
                        <div className="font-medium mb-4">Choose payment period</div>
                        <div>
                            <Button className="btn btn-primary mr-4 w-5/12" onClick={() => state?.setPlan()}>
                                $14 per month
                            </Button>
                            <Button className="btn btn-primary w-5/12" onClick={() => state?.setPlan()}>
                                $14 per year
                            </Button>
                        </div>
                        <div className="italic mt-6 text-m-gray-6">
                            Our standard plan is good for 10-100 millions page views a month, depending on how many
                            errors you generate. If you log more errors than this, we will give you time to fix your
                            most often logged errors.
                        </div>
                    </div>
                }
            >
                <div className="font-medium text-m-green">
                    1,000,000 errors / month <br />
                    Unlimited websites <br />
                    Unlimited users <br />
                    E-mail alerts <br />
                    E-mail support
                </div>
            </Card>
        </div>
    </div>;
});
